/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M50 14a3 3 0 00-3 3v30H17a3 3 0 000 6h30v30a3 3 0 006 0V53h30a3 3 0 000-6H53V17a3 3 0 00-3-3z"/>'
  }
})
